<template>
    <div id="ScanContainer">

        <div class="sv_q sv_qstn" style="width: 100%;">
            <h5 class="sv_q_title">
                <div class="message" :class="{'hidden':step!=0}">Stand straight with your hands on your waist and legs spread apart.</div>
                <div class="message" :class="{'hidden':step!=1}">Perfect, we’re scanning you now, hold still while we get your shot.</div>
                <div class="message" :class="{'hidden':step!=2 && step!=3}">Awesome! Scan complete.<br><br><span class="message-ext" :class="{'hidden':step!=3}">One second while we crunch the numbers.</span></div>
            </h5>
        </div>

        <div class="body-holder">
            <!-- Generator: Adobe Illustrator 23.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
            <svg version="1.1" id="Person" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 683.3 1303.3" style="enable-background:new 0 0 683.3 1303.3;" xml:space="preserve">
            <rect class="transparent" width="683.3" height="1303.3"/>
            <g id="backingPerson-holder" class="hidden">
                <path class="backingPerson backingPerson-left" d="M232.5,420.5c0.3,1.3,0.2,2.7-0.1,3.9l-21,76.1c-1.4,4.9-2.6,9.9-3.9,14.8l-0.1-0.1
                    l-91.4-77.8l106.5-24.3c4.4-1,8.7,1.7,9.7,6.1L232.5,420.5z M341.6,794.8h-4.7c-9.3,0-16.9,7.6-16.9,17v431.6
                    c0,9.8-4.2,19.5-11.4,26.3c-13.1,12.7-34.3,12.3-48.6,0.4l-0.8-0.8c-7.2-6-11.4-14-12.7-22.9l-59.2-431.1
                    c-7.2-50.9-7.6-101.8-1.7-152.6l8-69.9c0.6-5.5,1.4-11,2.1-16.5c-9.7,3-20.3,1.4-28.6-4.4L31.6,477.3c-13.6-9.5-21.9-25.6-21-43.4
                    c0.5-9.9,4.5-19.4,10.4-27.4l4.5-6c3.7-5.1,8.5-9.3,13.9-12.6l135.3-94c16.9-11.7,35.6-20.5,55.5-25.9c15.3-4.2,31.1-6.2,46.9-6.2
                    h64.5"/>
                <path class="backingPerson backingPerson-right" d="M459.4,412.9l107.8,24.6l-91.4,77.8c-0.2,0.2-0.5,0.5-0.8,0.7
                    c-1.4-5.7-2.7-11.5-4.3-17.1l-21-75.9c-0.4-1.4-0.4-2.9,0-4.3C450.9,414.5,455.2,411.9,459.4,412.9z M341.6,261.8h66.7
                    c12.9,0,25.7,1.4,38.4,4.2l5,1.1c24.1,5.3,46.9,15.5,66.9,30L643.9,388c5.4,3.3,10.1,7.6,13.9,12.6l4.4,5.9c6,8,9.9,17.4,10.4,27.4
                    c0.9,17.7-7.4,33.8-21,43.4l-135.6,94.3c-8.7,6.1-19.7,7.6-29.7,4.1c0.8,5.1,1.5,10.1,2.1,15.1l8.2,69.9
                    c5.9,50.9,5,102.2-1.7,152.6l-59.2,431.2c-1.3,8.9-5.9,17-12.7,22.9l-2.1,1.7c-16.5,14-41.4,10.7-53.2-8c-3.8-6-5.5-13.1-5.5-20.3
                    v-429c0-9.3-7.6-17-16.9-17h-3.8"/>
                <path class="backingPerson backingPerson-head" d="M341.6,226.2c-57.2,0-103.6-46.4-103.6-103.6S284.4,19,341.6,19
                    s103.6,46.4,103.6,103.6S398.8,226.2,341.6,226.2"/>
            </g>
            <g id="fluidPerson-holder" :class="{'hidden':state.completed}">
                <defs>
                    <path id="personMask" d="M672.7,433.9c-0.5-9.9-4.4-19.4-10.4-27.4l-4.4-5.9c-3.8-5.1-8.5-9.3-13.9-12.6l-125.3-90.9
                        c-20-14.5-42.8-24.7-66.9-30l-5-1.1c-12.6-2.7-25.5-4.2-38.4-4.2h-66.7h-64.5c-15.8,0-31.6,2.1-46.9,6.2
                        c-19.9,5.4-38.6,14.2-55.5,25.9L39.4,388c-5.4,3.3-10.1,7.6-13.9,12.6l-4.5,6c-5.9,8-9.9,17.4-10.4,27.4
                        c-0.9,17.7,7.4,33.8,21,43.4l135.6,94.3c8.4,5.8,19,7.4,28.6,4.4c-0.8,5.5-1.5,10.9-2.1,16.5l-8,69.9
                        c-5.9,50.9-5.5,101.8,1.7,152.6l59.2,431.1c1.2,8.9,5.5,16.9,12.7,22.9l0.8,0.8c14.3,11.9,35.5,12.3,48.6-0.4
                        c7.2-6.8,11.4-16.5,11.4-26.3V811.7c0-9.3,7.6-17,16.9-17h4.7h3.8c9.3,0,16.9,7.6,16.9,17v429c0,7.2,1.7,14.4,5.5,20.3
                        c11.9,18.7,36.8,22.1,53.2,8l2.1-1.7c6.8-5.9,11.4-14,12.7-22.9L495,813.3c6.8-50.4,7.6-101.8,1.7-152.6l-8.2-69.9
                        c-0.6-5.1-1.4-10.1-2.1-15.1c10,3.5,21,2,29.7-4.1l135.6-94.3C665.3,467.8,673.6,451.6,672.7,433.9z M232.4,424.5l-21,76.1
                        c-1.4,4.9-2.6,9.9-3.9,14.8l-0.1-0.1l-91.4-77.8l106.5-24.3c4.4-1,8.7,1.7,9.7,6.1l0.3,1.2C232.8,421.8,232.8,423.2,232.4,424.5z
                        M475.8,515.3c-0.2,0.2-0.5,0.5-0.8,0.7c-1.4-5.7-2.7-11.5-4.3-17.1l-21-75.9c-0.4-1.4-0.4-2.9,0-4.3c1.1-4.2,5.4-6.8,9.6-5.8
                        l107.8,24.6L475.8,515.3z M341.6,226.2c-57.2,0-103.6-46.4-103.6-103.6S284.4,19,341.6,19s103.6,46.4,103.6,103.6
                        S398.8,226.2,341.6,226.2"/>
                </defs>
                <clipPath id="personMask_1_">
                    <use xlink:href="#personMask"  style="overflow:visible;"/>
                </clipPath>
                <g id="waves" class="waves-clip">
                <g class="wave-group" :class="{'fill-up':state.loaded}">
                    <path class="waves-color tall-wave" :class="{'tall-wave-move':state.loaded}" d="M1096.6-248.7c-113.1,33-93.3-91.2-214.5-108c-73.1-10.1-123.6,45.4-154.8,99
                        c-22.7,39.2-73.1,51.7-112.2,28.9c-34.8-20.3-79.6-34.3-129-19.9c-113.1,33-93.3-91.2-214.5-108c-75-10.4-126.3,41.4-157.2,90.2
                        c-22.1,34.8-66.7,47.5-104,29.8c-35.4-16.7-82.2-28.1-134.1-12.9c-113.1,33-93.3-91.2-214.5-108c-110-15.2-168.9,85.8-187.5,125.5
                        c-4.4,9.3-6.6,19.5-6.6,29.7v1486.7H77.5l0,0h610.4h609.2V-153.1c0-9.8-3.7-19.2-10.4-26.4
                        C1259.1-208.9,1185.4-274.6,1096.6-248.7z"/>
                    <path class="waves-color mid-wave" :class="{'mid-wave-move':state.loaded}" d="M1057.6-169.1c-118.9,24.8-97.4,45.6-240.8,15.7c-62-12.9-95.2-0.7-112.9,17.3c-16.7,17-42.6,20.8-63.3,8.9
                        c-46.4-26.8-119.9-58.1-192.3-42.9c-118.9,24.8-97.4,45.6-240.8,15.7c-61.6-12.9-94.8-0.9-112.5,17c-16.9,16.9-42.9,20.9-63.7,9.1
                        c-46.5-26.5-118.9-56.6-190.2-41.7c-118.9,24.8-97.4,45.6-240.8,15.7s-132.6,74.6-132.6,74.6v1364.1H75h7h602.2h0
                        c0,0,612.9,0,612.9,0V-93.6C1297.1-93.6,1176.5-194,1057.6-169.1z"/>
                    <path class="waves-color small-wave" :class="{'small-wave-move':state.loaded}" d="M1121.2-74.7C1016.2-76.2,990.9,15,881.4,15c-29.4,0-57.3,1.4-82.3,3.5c-64,5.3-128-12.8-179-51.8
                        c-28.7-21.9-65.9-40.8-109.3-41.4C405.8-76.2,380.4,15,270.9,15c-31,0-60.2,1.1-86.2,2.6C123.3,21.2,62.4,3.2,13.3-33.9
                        C-15.2-55.6-52.1-74.1-95.2-74.7C-200.1-76.2-225.5,15-335,15c-75.6,0-140.8-10.4-174-16.8c-12.1-2.3-23.3,6.9-23.3,19.2v1266.9
                        H73.7h4.6h605.9c0,0,613,0,613,0V34.8C1297.1,34.8,1226.1-73.2,1121.2-74.7z"/>
                </g>
            </g>
            </g>
            <g id="fadedPerson-holder" :class="{'hidden':state.completed}">
                <path class="fadedPerson fadedPerson-left" d="M232.5,420.5c0.3,1.3,0.2,2.7-0.1,3.9l-21,76.1c-1.4,4.9-2.6,9.9-3.9,14.8l-0.1-0.1
                    l-91.4-77.8l106.5-24.3c4.4-1,8.7,1.7,9.7,6.1L232.5,420.5z M341.6,794.8h-4.7c-9.3,0-16.9,7.6-16.9,17v431.6
                    c0,9.8-4.2,19.5-11.4,26.3c-13.1,12.7-34.3,12.3-48.6,0.4l-0.8-0.8c-7.2-6-11.4-14-12.7-22.9l-59.2-431.1
                    c-7.2-50.9-7.6-101.8-1.7-152.6l8-69.9c0.6-5.5,1.4-11,2.1-16.5c-9.7,3-20.3,1.4-28.6-4.4L31.6,477.3c-13.6-9.5-21.9-25.6-21-43.4
                    c0.5-9.9,4.5-19.4,10.4-27.4l4.5-6c3.7-5.1,8.5-9.3,13.9-12.6l135.3-94c16.9-11.7,35.6-20.5,55.5-25.9c15.3-4.2,31.1-6.2,46.9-6.2
                    h64.5"/>
                <path class="fadedPerson fadedPerson-right" d="M459.4,412.9l107.8,24.6l-91.4,77.8c-0.2,0.2-0.5,0.5-0.8,0.7
                    c-1.4-5.7-2.7-11.5-4.3-17.1l-21-75.9c-0.4-1.4-0.4-2.9,0-4.3C450.9,414.5,455.2,411.9,459.4,412.9z M341.6,261.8h66.7
                    c12.9,0,25.7,1.4,38.4,4.2l5,1.1c24.1,5.3,46.9,15.5,66.9,30L643.9,388c5.4,3.3,10.1,7.6,13.9,12.6l4.4,5.9c6,8,9.9,17.4,10.4,27.4
                    c0.9,17.7-7.4,33.8-21,43.4l-135.6,94.3c-8.7,6.1-19.7,7.6-29.7,4.1c0.8,5.1,1.5,10.1,2.1,15.1l8.2,69.9
                    c5.9,50.9,5,102.2-1.7,152.6l-59.2,431.2c-1.3,8.9-5.9,17-12.7,22.9l-2.1,1.7c-16.5,14-41.4,10.7-53.2-8c-3.8-6-5.5-13.1-5.5-20.3
                    v-429c0-9.3-7.6-17-16.9-17h-3.8"/>
                <path class="fadedPerson fadedPerson-head" d="M341.6,226.2c-57.2,0-103.6-46.4-103.6-103.6S284.4,19,341.6,19s103.6,46.4,103.6,103.6
                    S398.8,226.2,341.6,226.2"/>
            </g>
            <g id="mintPerson-holder" :class="{'hidden':state.completed}">
                <path class="mintPerson mintPerson-left" :class="{'activeAnim1':state.loaded}" d="M232.5,420.5c0.3,1.3,0.2,2.7-0.1,3.9l-21,76.1c-1.4,4.9-2.6,9.9-3.9,14.8l-0.1-0.1
                    l-91.4-77.8l106.5-24.3c4.4-1,8.7,1.7,9.7,6.1L232.5,420.5z M341.6,794.8h-4.7c-9.3,0-16.9,7.6-16.9,17v431.6
                    c0,9.8-4.2,19.5-11.4,26.3c-13.1,12.7-34.3,12.3-48.6,0.4l-0.8-0.8c-7.2-6-11.4-14-12.7-22.9l-59.2-431.1
                    c-7.2-50.9-7.6-101.8-1.7-152.6l8-69.9c0.6-5.5,1.4-11,2.1-16.5c-9.7,3-20.3,1.4-28.6-4.4L31.6,477.3c-13.6-9.5-21.9-25.6-21-43.4
                    c0.5-9.9,4.5-19.4,10.4-27.4l4.5-6c3.7-5.1,8.5-9.3,13.9-12.6l135.3-94c16.9-11.7,35.6-20.5,55.5-25.9c15.3-4.2,31.1-6.2,46.9-6.2
                    h64.5"/>
                <path class="mintPerson mintPerson-right" :class="{'activeAnim1-reverse':state.loaded}" d="M459.4,412.9l107.8,24.6l-91.4,77.8c-0.2,0.2-0.5,0.5-0.8,0.7
                    c-1.4-5.7-2.7-11.5-4.3-17.1l-21-75.9c-0.4-1.4-0.4-2.9,0-4.3C450.9,414.5,455.2,411.9,459.4,412.9z M341.6,261.8h66.7
                    c12.9,0,25.7,1.4,38.4,4.2l5,1.1c24.1,5.3,46.9,15.5,66.9,30L643.9,388c5.4,3.3,10.1,7.6,13.9,12.6l4.4,5.9c6,8,9.9,17.4,10.4,27.4
                    c0.9,17.7-7.4,33.8-21,43.4l-135.6,94.3c-8.7,6.1-19.7,7.6-29.7,4.1c0.8,5.1,1.5,10.1,2.1,15.1l8.2,69.9
                    c5.9,50.9,5,102.2-1.7,152.6l-59.2,431.2c-1.3,8.9-5.9,17-12.7,22.9l-2.1,1.7c-16.5,14-41.4,10.7-53.2-8c-3.8-6-5.5-13.1-5.5-20.3
                    v-429c0-9.3-7.6-17-16.9-17h-3.8"/>
                <path class="mintPerson mintPerson-head" :class="{'activeAnim1-long':state.loaded}" d="M341.6,226.2c-57.2,0-103.6-46.4-103.6-103.6S284.4,19,341.6,19s103.6,46.4,103.6,103.6
                    S398.8,226.2,341.6,226.2"/>
            </g>
            <g id="whitePerson-holder" :class="{'hidden':state.completed}">
                <path class="whitePerson whitePerson-left" :class="{'activeAnim2':state.loaded}" d="M232.5,420.5c0.3,1.3,0.2,2.7-0.1,3.9l-21,76.1c-1.4,4.9-2.6,9.9-3.9,14.8l-0.1-0.1
                    l-91.4-77.8l106.5-24.3c4.4-1,8.7,1.7,9.7,6.1L232.5,420.5z M341.6,794.8h-4.7c-9.3,0-16.9,7.6-16.9,17v431.6
                    c0,9.8-4.2,19.5-11.4,26.3c-13.1,12.7-34.3,12.3-48.6,0.4l-0.8-0.8c-7.2-6-11.4-14-12.7-22.9l-59.2-431.1
                    c-7.2-50.9-7.6-101.8-1.7-152.6l8-69.9c0.6-5.5,1.4-11,2.1-16.5c-9.7,3-20.3,1.4-28.6-4.4L31.6,477.3c-13.6-9.5-21.9-25.6-21-43.4
                    c0.5-9.9,4.5-19.4,10.4-27.4l4.5-6c3.7-5.1,8.5-9.3,13.9-12.6l135.3-94c16.9-11.7,35.6-20.5,55.5-25.9c15.3-4.2,31.1-6.2,46.9-6.2
                    h64.5"/>
                <path class="whitePerson whitePerson-right" :class="{'activeAnim2-reverse':state.loaded}" d="M459.4,412.9l107.8,24.6l-91.4,77.8c-0.2,0.2-0.5,0.5-0.8,0.7
                    c-1.4-5.7-2.7-11.5-4.3-17.1l-21-75.9c-0.4-1.4-0.4-2.9,0-4.3C450.9,414.5,455.2,411.9,459.4,412.9z M341.6,261.8h66.7
                    c12.9,0,25.7,1.4,38.4,4.2l5,1.1c24.1,5.3,46.9,15.5,66.9,30L643.9,388c5.4,3.3,10.1,7.6,13.9,12.6l4.4,5.9c6,8,9.9,17.4,10.4,27.4
                    c0.9,17.7-7.4,33.8-21,43.4l-135.6,94.3c-8.7,6.1-19.7,7.6-29.7,4.1c0.8,5.1,1.5,10.1,2.1,15.1l8.2,69.9
                    c5.9,50.9,5,102.2-1.7,152.6l-59.2,431.2c-1.3,8.9-5.9,17-12.7,22.9l-2.1,1.7c-16.5,14-41.4,10.7-53.2-8c-3.8-6-5.5-13.1-5.5-20.3
                    v-429c0-9.3-7.6-17-16.9-17h-3.8"/>
                <path class="whitePerson whitePerson-head" :class="{'activeAnim2-long':state.loaded}" d="M341.6,226.2c-57.2,0-103.6-46.4-103.6-103.6S284.4,19,341.6,19s103.6,46.4,103.6,103.6
                    S398.8,226.2,341.6,226.2"/>
            </g>
            <g id="orangePerson-holder" :class="{'hidden':state.completed}">
                <path class="orangePerson orangePerson-left" :class="{'activeAnim3':state.loaded}" d="M232.5,420.5c0.3,1.3,0.2,2.7-0.1,3.9l-21,76.1c-1.4,4.9-2.6,9.9-3.9,14.8l-0.1-0.1
                    l-91.4-77.8l106.5-24.3c4.4-1,8.7,1.7,9.7,6.1L232.5,420.5z M341.6,794.8h-4.7c-9.3,0-16.9,7.6-16.9,17v431.6
                    c0,9.8-4.2,19.5-11.4,26.3c-13.1,12.7-34.3,12.3-48.6,0.4l-0.8-0.8c-7.2-6-11.4-14-12.7-22.9l-59.2-431.1
                    c-7.2-50.9-7.6-101.8-1.7-152.6l8-69.9c0.6-5.5,1.4-11,2.1-16.5c-9.7,3-20.3,1.4-28.6-4.4L31.6,477.3c-13.6-9.5-21.9-25.6-21-43.4
                    c0.5-9.9,4.5-19.4,10.4-27.4l4.5-6c3.7-5.1,8.5-9.3,13.9-12.6l135.3-94c16.9-11.7,35.6-20.5,55.5-25.9c15.3-4.2,31.1-6.2,46.9-6.2
                    h64.5"/>
                <path class="orangePerson orangePerson-right" :class="{'activeAnim3-reverse':state.loaded}" d="M459.4,412.9l107.8,24.6l-91.4,77.8c-0.2,0.2-0.5,0.5-0.8,0.7
                    c-1.4-5.7-2.7-11.5-4.3-17.1l-21-75.9c-0.4-1.4-0.4-2.9,0-4.3C450.9,414.5,455.2,411.9,459.4,412.9z M341.6,261.8h66.7
                    c12.9,0,25.7,1.4,38.4,4.2l5,1.1c24.1,5.3,46.9,15.5,66.9,30L643.9,388c5.4,3.3,10.1,7.6,13.9,12.6l4.4,5.9c6,8,9.9,17.4,10.4,27.4
                    c0.9,17.7-7.4,33.8-21,43.4l-135.6,94.3c-8.7,6.1-19.7,7.6-29.7,4.1c0.8,5.1,1.5,10.1,2.1,15.1l8.2,69.9
                    c5.9,50.9,5,102.2-1.7,152.6l-59.2,431.2c-1.3,8.9-5.9,17-12.7,22.9l-2.1,1.7c-16.5,14-41.4,10.7-53.2-8c-3.8-6-5.5-13.1-5.5-20.3
                    v-429c0-9.3-7.6-17-16.9-17h-3.8"/>
                <path class="orangePerson orangePerson-head" :class="{'activeAnim3-long':state.loaded}" d="M341.6,226.2c-57.2,0-103.6-46.4-103.6-103.6S284.4,19,341.6,19
                    s103.6,46.4,103.6,103.6S398.8,226.2,341.6,226.2"/>
            </g>
            <g id="topPerson-holder" :class="{'hidden':state.completed}">
                <path class="topPerson topPerson-left" :class="{'activeAnim4':state.loaded}" d="M232.5,420.5c0.3,1.3,0.2,2.7-0.1,3.9l-21,76.1c-1.4,4.9-2.6,9.9-3.9,14.8l-0.1-0.1
                    l-91.4-77.8l106.5-24.3c4.4-1,8.7,1.7,9.7,6.1L232.5,420.5z M341.6,794.8h-4.7c-9.3,0-16.9,7.6-16.9,17v431.6
                    c0,9.8-4.2,19.5-11.4,26.3c-13.1,12.7-34.3,12.3-48.6,0.4l-0.8-0.8c-7.2-6-11.4-14-12.7-22.9l-59.2-431.1
                    c-7.2-50.9-7.6-101.8-1.7-152.6l8-69.9c0.6-5.5,1.4-11,2.1-16.5c-9.7,3-20.3,1.4-28.6-4.4L31.6,477.3c-13.6-9.5-21.9-25.6-21-43.4
                    c0.5-9.9,4.5-19.4,10.4-27.4l4.5-6c3.7-5.1,8.5-9.3,13.9-12.6l135.3-94c16.9-11.7,35.6-20.5,55.5-25.9c15.3-4.2,31.1-6.2,46.9-6.2
                    h64.5"/>
                <path class="topPerson topPerson-right" :class="{'activeAnim4-reverse':state.loaded}" d="M459.4,412.9l107.8,24.6l-91.4,77.8c-0.2,0.2-0.5,0.5-0.8,0.7
                    c-1.4-5.7-2.7-11.5-4.3-17.1l-21-75.9c-0.4-1.4-0.4-2.9,0-4.3C450.9,414.5,455.2,411.9,459.4,412.9z M341.6,261.8h66.7
                    c12.9,0,25.7,1.4,38.4,4.2l5,1.1c24.1,5.3,46.9,15.5,66.9,30L643.9,388c5.4,3.3,10.1,7.6,13.9,12.6l4.4,5.9c6,8,9.9,17.4,10.4,27.4
                    c0.9,17.7-7.4,33.8-21,43.4l-135.6,94.3c-8.7,6.1-19.7,7.6-29.7,4.1c0.8,5.1,1.5,10.1,2.1,15.1l8.2,69.9
                    c5.9,50.9,5,102.2-1.7,152.6l-59.2,431.2c-1.3,8.9-5.9,17-12.7,22.9l-2.1,1.7c-16.5,14-41.4,10.7-53.2-8c-3.8-6-5.5-13.1-5.5-20.3
                    v-429c0-9.3-7.6-17-16.9-17h-3.8"/>
                <path class="topPerson topPerson-head" :class="{'activeAnim4-long':state.loaded}" d="M341.6,226.2c-57.2,0-103.6-46.4-103.6-103.6S284.4,19,341.6,19s103.6,46.4,103.6,103.6
                    S398.8,226.2,341.6,226.2"/>
            </g>
            <g id="spinner" :class="{ hidden:state.initial, 'push-down':state.completed}">
                <circle id="spinnerBack" class="spinner-cream" :class="{ hidden:!state.completed, fadeInLong:state.completed }" cx="341.6" cy="399.2" r="79"/>
                <g id="dots">
                    <circle class="st10" cx="341.6" cy="357.6" r="8"/>
                    <circle class="st11" cx="341.6" cy="440.9" r="8"/>
                    <circle class="st12" cx="371.1" cy="369.8" r="8"/>
                    <circle class="st13" cx="312.2" cy="428.7" r="8"/>
                    <circle class="st14" cx="383.2" cy="399.2" r="8"/>
                    <circle class="st15" cx="300" cy="399.2" r="8"/>
                    <ellipse transform="matrix(0.7071 -0.7071 0.7071 0.7071 -194.4356 387.9316)" class="st16" cx="371.1" cy="428.7" rx="8" ry="8"/>
                    <circle class="st17" cx="312.2" cy="369.8" r="8"/>
                </g>
            </g>
            </svg>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Intro',
    props: ['value', 'content'],
    mixins: [],
    data() {
        return {
            rate: 10,
            values: {
                height: null,
                width: null, 
                weight: null,
            },
            state: {
                initial: true,
                loaded: false,
                completed: false
            },
            step: 0,
            hasScanner: false // this.$isBooth
        }
    },

    components: {
    },
    ready() {
    },
    methods: {
        updateSelection: function () {
            this.$emit('input', this.values);
        },
        initialState() {
            this.step = 0
            this.state.initial = true
            this.state.loaded = false
            this.state.completed = false
        },
        loadState() {
            this.$scanAudio(true)
            this.step = 99 // hack to turn off text
            let stepTimer = setTimeout(() => {
                this.step = 1
            }, 1000)
            this.state.initial = false
            this.state.loaded = true
            this.state.completed = false
            let timeout = setTimeout(() => {
                this.completeState()
            }, 9000)
        },
        completeState() {
            this.$scanAudio(false)
            this.step = 99 // hack to turn off text
            let stepTimer = setTimeout(() => {
                this.step = 2
            }, 1000)
            this.state.initial = false
            this.state.loaded = true // this stays on
            this.state.completed = true
            // get all the values and update the survey!
            // --> from Camera // 
            this.values.height = 68
            this.values.width = 18
            // --> from Scale
            this.values.weight = 165 //lbs
            let timeout = setTimeout(() => {
                this.step = 3
                let timeout = setTimeout(() => {
                    this.updateSelection()
                }, 3000)
            }, 3000)
        }
    },

    computed: {
    },

    watch: {
    },

    created() {
    },

    destroyed() {
    },

    mounted() {
        this.$nextTick(() => {
            this.$waitAudio(true)
            if (!this.hasScanner) {
                let timeout = setTimeout(() => {
                    this.$waitAudio(false)
                    this.loadState()
                }, 7000)
            }
        })
    }

}
</script>

<style lang="scss">
@import "../styles/variables.scss"; // Colors
#ScanContainer {
    display:flex;
    flex-direction:column;
    align-items:center;
    align-content:center;
    justify-items:center;
    justify-content:center;

    .sv_q .sv_q_title {
        margin-top: -5vh;
        padding-left: 4vw;
        padding-right: 4vw;
        margin-bottom: 3.5vh;
        height: 12.5vh;
        position: relative;
        .message {
            transition: opacity .5s ease-out;
            position: absolute;
            padding-left: 4vw;
            padding-right: 4vw;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            &.hidden {
                opacity: 0;
            }
        }
        .message-ext {
            transition: opacity .5s;
            &.hidden {
                opacity: 0;
            }
        }
    }

    .body-holder {
        .transparent{fill:none;}
        .hidden{opacity:0;}
        .backingPerson{opacity:0.2;fill:$color-white;}
        .waves-clip{clip-path:url(#personMask_1_);}
        .waves-color{opacity:0.25;fill:$color-faintBlue;enable-background:new    ;}
        .fadedPerson{opacity:0.2;fill:none;stroke:$color-white;stroke-width:6;}
        .mintPerson{fill:none;stroke:$color-green;stroke-width:6;}
        .whitePerson{fill:none;stroke:$color-white;stroke-width:6;}
        .orangePerson{fill:none;stroke:$color-yellow;stroke-width:6;}
        .topPerson{fill:none;stroke:$color-white;stroke-width:6;}
        .spinner-cream{fill:$color-cream;}
        .st10{fill:$color-purple;}
        .st11{fill:$color-darkGreen;}
        .st12{fill:$color-yellow;}
        .st13{fill:$color-darkBlue;}
        .st14{fill:$color-orange;}
        .st15{fill:$color-skyBlue;}
        .st16{fill:$color-green;}
        .st17{fill:$color-red;}
    }
    .body-holder {
        width:60vw;
        height:100%;
    }
    .disabled {
        opacity:.3;
        pointer-events:none;
    }
    .button-holder {
        margin-top:1rem;
        display:flex;
        flex-direction:row;
        align-items:center;
        justify-content:center;
        width:100%;
    }
    button {
        background:transparent;
        box-shadow:none;
        font-family:helvetica-bold;
        padding:.75rem;
        width:30%;
        border: solid 4px $color-white !important;
        border-radius:3rem;
        border:none;
        font-size:1.2rem;
        color:$color-white;
        transition:all .5s ease;
        margin: 0 20px;
    }

    /*---------------=================================*/

    svg#Person {
        backface-visibility: hidden;
    }
    #mintPerson-holder {
        transition:opacity .5s ease;
    }
    .mintPerson-left{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    .mintPerson-right{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    .mintPerson-head{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    #whitePerson-holder {
        transition:opacity .5s ease;
    }
    .whitePerson-left{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    .whitePerson-right{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    .whitePerson-head{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    #orangePerson-holder {
        transition:opacity .5s ease;
    }
    .orangePerson-left{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    .orangePerson-right{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    .orangePerson-head{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    #topPerson-holder {
        transition:opacity .5s ease;
    }
    .topPerson-left{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    .topPerson-right{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }
    .topPerson-head{
        stroke-dasharray: 2000;
        stroke-dashoffset: 2000;
    }

    .wave-group {
        transform:translateY(120rem);
        transition:opacity .5s ease;
    }

    .tall-wave-move {
        animation-name: move;
        animation-duration: 3.2s; 
        animation-timing-function: linear; 
        animation-delay: 0s;
        animation-direction: alternate;
        animation-iteration-count: 5;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .mid-wave-move {
        animation-name: move;
        animation-duration: 3.2s; 
        animation-timing-function: linear; 
        animation-delay: .2s;
        animation-direction: alternate-reverse;
        animation-iteration-count: 5;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .small-wave-move {
        animation-name: move;
        animation-duration: 3.2s; 
        animation-timing-function: linear; 
        animation-delay: .5s;
        animation-direction: alternate;
        animation-iteration-count: 5;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    @keyframes move {
        0%{
            transform:translateX(34rem);
        }
        100%{
            transform:translateX(-39rem);
        }
    }

    .fill-up {
        animation-name: fill;
        animation-duration: 7s; 
        animation-timing-function: ease; 
        animation-delay: 0s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    @keyframes fill {
        0%{
            transform:translateY(120rem);
        }
            100%{
            transform:translateY(0rem);
        }
    }

    #spinner {
        transition:all .5s ease;
    }

    #dots {
        animation-name: spin;
        animation-duration: 3s; 
        animation-timing-function: linear; 
        animation-delay: 0s;
        animation-direction: forwards;
        animation-iteration-count: infinite;
        animation-fill-mode: forwards;
        animation-play-state: running;
        transform-box: fill-box;
        transform-origin:center center;
    }

    .push-down {
        transform: translateY(10rem);
    }

    .fadeInLong {
        animation-name: fade;
        animation-duration: .5s; 
        animation-timing-function: ease; 
        animation-delay: 7s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    @keyframes dash {
        to {
            stroke-dashoffset: 0;
        }
    }

    @keyframes fade {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }


    @keyframes dash-reverse {
        to {
            stroke-dashoffset: 4000;
        }
    }

    @keyframes spin {
        0%{
            transform:rotate(0deg);
        }
            100%{
            transform:rotate(360deg);
        }
    }




    .activeAnim1 {
        animation-name: dash;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: 0s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim1-reverse {
        animation-name: dash-reverse;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: 0s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim1-long {
        animation-name: dash-reverse;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: 1s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim2 {
        animation-name: dash;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: .5s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim2-reverse {
        animation-name: dash-reverse;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: .5s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim2-long {
        animation-name: dash-reverse;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: 1.5s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim3 {
        animation-name: dash;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: 1s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim3-reverse {
        animation-name: dash-reverse;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: 1s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim3-long {
        animation-name: dash-reverse;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: 2s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim4 {
        animation-name: dash;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: 1.5s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim4-reverse {
        animation-name: dash-reverse;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: 1.5s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

    .activeAnim4-long {
        animation-name: dash-reverse;
        animation-duration: 3s; 
        animation-timing-function: ease-out; 
        animation-delay: 2.5s;
        animation-direction: forwards;
        animation-iteration-count: once;
        animation-fill-mode: forwards;
        animation-play-state: running;
    }

}

</style>